import { COLOR } from "../../../../common/Color"
import { Align } from "../../../../common/TextUtils"
import { PhaserText, PhaserTextConfig } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { EveryCigAtlases } from "../EveryCigAssets"
import { EveryCigSprite } from "../EveryCigTypes"

export class EveryCigWarningScreen implements EveryCigSprite {
    private static disclaimerText = [
        {text: "WARNING", y: Scale.y(0.05), title: true},
        {text: "This activity contains graphic images that may disturb you.", y: Scale.y(0.151)},
        {text: "You may want to close your eyes if you’re easily upset.", y: Scale.y(0.34)},
        {text: "Click “Continue” to start this activity.", y: Scale.y(0.54)}
    ]

    sprite: Phaser.Sprite
    private close: Phaser.Tween
    private texts: Array<Phaser.Text>

    constructor(
        private game: Phaser.Game,
        private group: Phaser.Group,
        x: number,
        y: number
    ) {
        this.texts = []
        this.sprite = Sprites.add(game, EveryCigAtlases.WARNING_SCREEN, {debug: true, x, y, group})
        this.close = this.game.add.tween(this.sprite).to({y: Scale.y(-1.5)}, 1000, Phaser.Easing.Linear.None, false)

        const textConfig: PhaserTextConfig = {debug: true, group, align: Align.CENTER, wordWrapWidth: 0.4, fontPx: 20}
        const titleTextConfig: PhaserTextConfig = {color: COLOR.red, debug: true, group, align: Align.CENTER}
        EveryCigWarningScreen.disclaimerText.forEach(text => {
            const current = PhaserText.create(game, text.text, text.title ? titleTextConfig : textConfig)
            Sprites.centerTextInSprite(this.sprite, current)
            current.x += Scale.x(0.005)
            current.y = text.y
            this.texts.push(current)
        })
    }

    destroy = () => {
        this.close.onStart.add(() => this.texts.forEach(text => text.destroy(true)))
        this.close.onComplete.add(() => this.sprite.destroy(true))
        this.close.start()
    }
}
